var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"websales-app"}},[_c('ul',{staticClass:"skip-links"},[_c('li',[_c('a',{ref:"skipLink",staticClass:"skip-link",attrs:{"href":"#wb-cont"}},[_vm._v(_vm._s(_vm.$t('Skip to main content')))])])]),_c('VueAnnouncer'),_c('appHeader'),_c('div',{attrs:{"role":"main"}},[_c('router-view')],1),_c('appFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }